var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 58,
    rx: 6,
    fill: "#445162",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6182 42.7139C33.8625 43.3578 32.648 43.367 31.8965 42.7129H31.8975L17.7119 30.4941V30.5L17.3809 30.2158C16.6065 29.5488 16.6054 28.4537 17.3818 27.792L31.8975 15.2891C32.6543 14.6373 33.8695 14.6365 34.6201 15.29C35.3843 15.9557 35.3958 17.0492 34.6191 17.7119L21.5127 29.002L34.6191 40.291C35.3932 40.9581 35.3945 42.0523 34.6182 42.7139Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryArrowLeft);
export default __webpack_public_path__ + "static/media/gallery-arrow-left.6a9108178b7f2a32f1274a4925a45ca7.svg";
export { ForwardRef as ReactComponent };